import React, { useEffect, useState } from 'react';
import { getOverallPayment } from '../../api/Api'; // Adjust the import path as necessary
import Loader from '../../Loader/Loader';
import { PiHandCoins } from "react-icons/pi";
const AllPAyment = ({remainingVocher}) => {
  const [total, setTotalPaid] = useState(0);
  const [loading, setLoading] = useState(true);
  const [balanceAmount, setBalanceAmount] = useState(0); 
  useEffect(() => {
    const fetchOverallPayment = async () => {
      try {
        const response = await getOverallPayment();
        if (response.success) {
          setTotalPaid(response.totalPaid);
          setBalanceAmount(response.BalanceAmount);

        } else {
          console.log("Failed to fetch overall payment.");
        }
      } catch (error) {
        console.error("Error fetching overall payment:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOverallPayment();
  }, []);
  return (
    <div className="p-4">
      {loading ? (
        <Loader />
      ) : (   < >
      <div className='flex   font-semibold space-x-1'>
      <div className=' space-x-2 flex items-center px-2 py-2 bg-[#16bab1] text-white rounded-md shadow-lg'>
      <span className='text-md'>  In</span><span className="   ">
                = ₹{total}
              </span>
        </div>
        <div className=' space-x-2 flex items-center px-2 py-2 bg-[#16bab1] text-white rounded-md shadow-lg'>
      <span className='text-md      '>  Out</span><span className="    ">
                 =  ₹{remainingVocher}
              </span>
        </div>
        <div className=' space-x-2  flex items-center px-2 py-2 bg-[#16bab1] text-white rounded-md shadow-lg'>
      <span className='text-md'>Balance</span><span className="     ">
              = ₹{balanceAmount}
              </span>
        </div>
      </div>
  
        </>
      )}
    </div>
  );
};

export default AllPAyment;